import i18next from 'i18next'
import {OnlinePaymentStatus} from '@/constants/online-payment-status'
import {POSPaymentStateStatus} from '@/constants/pos-payment-state-status'
import {PaymentsStatus, PaymentsType} from '~/code/constants'

export const convertEcomStatusesToSelectItems = (statuses: OnlinePaymentStatus[]) =>
    statuses.map((item) => ({
        label: i18next.t(`enums:onlinePaymentStatus.${item}`),
        value: item
    }))

export const convertPosStatesToSelectItems = (states: POSPaymentStateStatus[]) =>
    states.map((item) => ({
        label: i18next.t(`enums:posPaymentStateStatus.${item}`),
        value: item
    }))

export const convertPaymentsStatusesToSelectItems = (states: PaymentsStatus[]) =>
    states.map((item) => ({
        label: i18next.t(`enums:paymentsStatus.${item}`),
        value: item
    }))

export const convertPaymentsTypesToSelectItems = (types: PaymentsType[]) =>
    types.map((type) => ({
        label: i18next.t(`enums:paymentsType.${type}`),
        value: type
    }))
